import { render, staticRenderFns } from "./OrderDetailsField.vue?vue&type=template&id=b09f9280&scoped=true&"
import script from "./OrderDetailsField.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09f9280",
  null
  
)

export default component.exports